import * as React from 'react';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import { TournamentReportPeriodForm } from '../TournamentReportPeriodForm';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
}

export function UnionMemberSchoolsTournamentsAsPartOfUnionReportForm(props: Props) {
  return (
    <TournamentReportPeriodForm
      {...props}
      reportType={REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.UNION_MEMBER_SCHOOLS_TOURNAMENTS_AS_PART_OF_UNION}
      description="View tournaments where students from member schools participated as part of a consolidated area team."
    />
  );
}
